<template>
    <!-- Page Content Wrapper -->
    <div id="page-content-wrapper" class="admin-content-area">
        <div class="container-fluid xyz">
            <div class="page-header-top-container">
                <div class="page-name" style="width:100%">Mobile Application</div>
            </div>
            <!--page content-->
            <div class="admin-page-content">
                <!--Forms-->
                <div :class="alertClass" id="success-alert">
                    <strong> {{alertMessage}} </strong>
                </div>
                <div class="forms-container add_user_forms_container">
                    <div class="row no-margin">
                        <!-- For Type -->
                        <div class="col-12 forms-block">
                            <!-- <div class="col-3 paddingleft0">
                                <div class="form-label">Date :</div>
                            </div> -->
                            <div class="col-9 paddingleft0">
                                <b-form-radio-group v-model="forType" :options="forTypeOption" name="forType"></b-form-radio-group>
                            </div>
                        </div>
                        <template v-if="forType == 'customer'">
                            <!-- Customer -->
                            <div class="col-12 forms-block">
                                <div class="col-3 paddingleft0">
                                    <div class="form-label">Customer :</div>
                                </div>
                                <div class="col-9 paddingleft0">
                                    <v-select v-model="customerId"
                                        name="customerId"
                                        id="customerId"
                                        label="text"
                                        :filterable="true"
                                        :options="customerArr"
                                        :clearable=false
                                        @input="onChnageCustomer()"
                                        placeholder="Select Customer">
                                    </v-select>
                                    <div class="requiredstar">*</div>
                                    <span class="text-danger">{{customerError}}</span>
                                </div>
                            </div>
                        </template>
                        <template v-else>
                            <!-- User -->
                            <div class="col-12 forms-block">
                                <div class="col-3 paddingleft0">
                                    <div class="form-label">User :</div>
                                </div>
                                <div class="col-9 paddingleft0">
                                    <v-select v-model="userId"
                                        class="multi-select-list"
                                        multiple
                                        name="userId"
                                        id="userId"
                                        label="text"
                                        :filterable="true"
                                        :options="userArr"
                                        :clearable=false
                                        @input="onChnageCustomer()"
                                        placeholder="Select User">
                                    </v-select>
                                    <div class="requiredstar">*</div>
                                    <span class="text-danger">{{userError}}</span>
                                </div>
                            </div>
                        </template>
                    </div>
                    <!--Error Alert-->
                    <div class="row clearfix" >
                        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                            <div class="alert alert-danger" id="alertError">
                                <strong id="errorMsg" class="error"></strong>
                            </div>
                        </div>
                    </div>
                    <div class="clearfix"></div>
                    <!--Buttons-->
                    <div class="row clearfix"></div>
                    <div class="button-demo">
                        <input id="addBenifitBtn" :disabled="disableButtons.save" type="submit" :value="buttonNames.save" class="btn btn-primary my-1 ms-2" v-on:click.prevent="generateApplicationLink()">
                        <input type="submit" value='Copy Android Link' class='btn btn-primary my-1 ms-2' v-on:click.prevent="copyAndroidLink()">
                    </div>
                </div>
                <!-- Forms -->
            </div>
            <!--page content-->
        </div>
        <app-footer></app-footer>
    </div>
    <!-- Page Content Wrapper -->
</template>

<script>
    var self;
    import Vue from 'vue';
    import vSelect from 'vue-select';
    import Footer from '@/components/partials/Footer';
    import EventBus from '.././event-bus';
    import {commonMixins} from '../../mixins/commonMixins';
    import {HTTP} from '../../http-common.js';
    var moment = require('moment-timezone');

    export default {
        name: 'MobileApplication',
        mixins: [commonMixins],
        components: {
            'app-footer': Footer,
            'v-select': vSelect,
        },
        data() {
            return {
                alertClass : '',
                alertMessage : '',
                forType:"customer",
                forTypeOption:[
                    {text: 'Customer', value: 'customer'},
                    {text: 'User', value: 'user'},
                ],
                customerId: "",
                customerArr: [],
                customerError: "",
                userId: "",
                userArr: [],
                userError: "",
                buttonNames : {
                    save : 'Generate iOS App Link',
                },
                disableButtons : {
                    save : false,
                },
                androidAppLink: 'https://play.google.com/store/apps/details?id=com.vvg.partsconsignment',
            }
        },
        beforeMount: function () {
            self = this;
            EventBus.$emit("menu-selection-changed", "mobileApplication");
        },
        watch: {
            forType: function() {
                self.customerError = self.userError = '';
            }
        },
        mounted: function () {
            $("#alertError").hide();

            self.getAllCustomer();
            self.getAllUser();
        },
        methods: {
            onChnageCustomer: function() {
                self.customerError = "";
            },
            copyAndroidLink: function() {
                navigator.clipboard.writeText(self.androidAppLink);
            },
            getAllCustomer: function() {
                var config = {
                    headers: {
                        Authorization:localStorage.getItem("access_token")
                    },
                };
                HTTP.get('/customer/all/get', config)
                    .then(function (response) {
                        if (response.status == '200') {
                            self.customerArr = response.data.content;
                        }
                    })
                    .catch(function (err) {
                        self.catchHandler(err);
                    })
            },
            getAllUser: function() {
                var config = {
                    headers: {
                        Authorization:localStorage.getItem("access_token")
                    },
                };
                HTTP.get('/user/all/get', config)
                    .then(function (response) {
                        if (response.status == '200') {
                            self.userArr = response.data.content;
                        }
                    })
                    .catch(function (err) {
                        self.catchHandler(err);
                    })
            },
            checkForm: function() {
                var checked = true;
                self.customerError = '';
                self.userError = '';

                if(self.forType == 'customer') {
                    if (self.customerId == null || !self.customerId.value) {
                        self.customerError = "Select Customer";
                        checked = false;
                    }
                }
                if(self.forType == 'user') {
                    // if (self.userId == null || !self.userId.value) {
                    if (self.userId.length == 0) {
                        self.userError = "Select User";
                        checked = false;
                    }
                }
                return checked;
            },
            generateApplicationLink: function() {
                setTimeout(() => {
                    if (self.checkForm()) {
                        var config = {
                            headers: {Authorization:localStorage.getItem("access_token")},
                        };
                        self.disableButtons.save = true;
                        self.buttonNames.save = "Generating ...";
                        var fields = {};
                        if(self.forType == 'customer') {
                            fields = {
                                customer_id: self.customerId.value,
                            };
                        } else {
                            var userIdValue = '';
                            if( self.userId && self.userId.length > 0 ) {
                                for (var i = 0; i < self.userId.length; i++) {
                                    userIdValue += (self.userId[i].value) + ',';
                                }
                                userIdValue = userIdValue.replace(/,\s*$/, "");
                            }
                            fields = {
                                user_id: userIdValue,
                            };
                        }
                        
                        self.showLoader();
                        HTTP.post("/mobile/application/link/generate", fields, config)
                            .then(function (response) {
                                self.hideLoader();
                                self.disableButtons.save = false;
                                self.buttonNames.save = "Generate iOS App Link";
                                if (response.data.status == "success") {
                                    self.showSAlert(response.data.content, 'success');
                                    self.forType = 'customer';
                                    self.customerId = '';
                                    self.userId = '';
                                } else {
                                    self.showSAlert(response.data.content, 'info');
                                }
                            })
                            .catch(function (err) {
                                self.hideLoader();
                                self.disableButtons.save = false;
                                self.buttonNames.save = "Generate iOS App Link";
                                self.catchHandler(err);
                            });
                    }
                }, 200);
            },
        },
    }
</script>


// WEBPACK FOOTER //
// src/components/MobileApplicationMaster/MobileApplication.vue